import { useState, type FormEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import { PASSWORD_MIN_LENGTH } from '@tengesa/shared';
import { api } from '../../lib/api';
import { Button, Field, FormError, TextInput, fieldErrors, useToast } from '../../ui';

export function PasswordForm({ onDone, submitLabel = 'Change password' }: { onDone?: () => void; submitLabel?: string }) {
  const toast = useToast();
  const [currentPassword, setCurrent] = useState('');
  const [newPassword, setNew] = useState('');
  const [confirm, setConfirm] = useState('');
  const [mismatch, setMismatch] = useState(false);
  const m = useMutation({
    mutationFn: () => api.post('/api/auth/change-password', { currentPassword, newPassword }),
    onSuccess: () => {
      toast('Password changed. Your other devices have been signed out.');
      setCurrent('');
      setNew('');
      setConfirm('');
      onDone?.();
    },
  });
  const f = fieldErrors(m.error);
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirm) {
      setMismatch(true);
      return;
    }
    setMismatch(false);
    m.mutate();
  };
  return (
    <form onSubmit={submit} className="space-y-4" noValidate>
      {m.error && !Object.keys(f).length ? <FormError error={m.error} /> : null}
      <Field label="Current password" htmlFor="cur" error={f.currentPassword}>
        <TextInput id="cur" type="password" autoComplete="current-password" value={currentPassword} onChange={(e) => setCurrent(e.target.value)} invalid={!!f.currentPassword} />
      </Field>
      <Field label="New password" htmlFor="new" error={f.newPassword} hint={`At least ${PASSWORD_MIN_LENGTH} characters, with a letter and a number.`}>
        <TextInput id="new" type="password" autoComplete="new-password" value={newPassword} onChange={(e) => setNew(e.target.value)} invalid={!!f.newPassword} />
      </Field>
      <Field label="Type the new password again" htmlFor="confirm" error={mismatch ? 'The passwords don’t match' : undefined}>
        <TextInput id="confirm" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} invalid={mismatch} />
      </Field>
      <Button type="submit" variant="primary" busy={m.isPending}>
        {submitLabel}
      </Button>
    </form>
  );
}
